<template>
  <div class="wrapper">
    <div class="bottom-navigation">
      <div
        v-for="item in items"
        :key="item.text"
        :class="['nav-item', { 
          'wallet-button': item.text === $t('navigation.wallet'), 
          'selected': activeItem === item.text 
        }]"
        @click="navigate(item)"
      >
       <!-- Wallet özel altıgen -->
<div v-if="item.text === $t('navigation.wallet')" class="hexagon">
  <div v-html="item.icon" class="wallet-icon"></div>
</div>
<span v-if="item.text === $t('navigation.wallet')" class="nav-text" :class="{ 'selected-text': activeItem === item.text }">
  {{ item.text }}
</span>


        <!-- Diğer menüler -->
        <template v-else>
          <div v-html="item.icon" class="nav-icon"></div>
          <span class="nav-text" :class="{ 'selected-text': activeItem === item.text }">
            {{ item.text }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      items: [
        { 
          text: this.$t("navigation.menu"), 
          type: "sidebar",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                   <defs>
                     <linearGradient id="navGradient" gradientTransform="rotate(420)">
                       <stop offset="0%" stop-color="rgb(255,206,0)" />
                       <stop offset="49%" stop-color="rgb(255,206,0)" />
                       <stop offset="49%" stop-color="rgb(255,184,0)" />
                       <stop offset="100%" stop-color="rgb(255,184,0)" />
                     </linearGradient>
                   </defs>
                   <path d="M3 6h18v2H3zm0 5h18v2H3zm0 5h18v2H3z" />
                 </svg>`
        },
        { 
          text: this.$t("sidebar.affiliate"), 
          route: "/affiliates",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="#7b6cb9" d="M20.75 6a1.25 1.25 0 0 1 0 2.5h-7.5a4.75 4.75 0 0 0-4.75 4.75v21.5a4.75 4.75 0 0 0 4.75 4.75h21.5a4.75 4.75 0 0 0 4.75-4.75v-6.5a1.25 1.25 0 0 1 2.5 0v6.5A7.25 7.25 0 0 1 34.75 42h-21.5A7.25 7.25 0 0 1 6 34.75v-21.5A7.25 7.25 0 0 1 13.25 6zm8.972-3.884a1.25 1.25 0 0 1 1.333.179l14.5 12.25a1.25 1.25 0 0 1 .036 1.878l-14.5 13.25a1.25 1.25 0 0 1-2.093-.923v-5.722c-2.055.098-4.022.47-6.038 1.467c-2.28 1.126-4.715 3.095-7.418 6.545l-.544.71a1.25 1.25 0 0 1-2.22-.476l-.027-.191c-.266-3.992.789-9.44 3.524-13.922c2.587-4.238 6.74-7.693 12.723-8.117V3.25c0-.487.282-.929.724-1.134"/></svg>`
        },
        { 
          text: this.$t("navigation.slot"), 
          route: "/",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#7b6cb9" d="m5 12l2-4V7H4v1h2l-2 4m5 0l2-4V7H8v1h2l-2 4m5 0l2-4V7h-3v1h2l-2 4m9-10c-1.1 0-2 .9-2 2c0 .7.4 1.4 1 1.7V17h-3v-2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-3.8c-.8-1.2-2.2-2-3.7-2s-2.9.8-3.7 2H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1v7h15v-3h3c1.1 0 2-.9 2-2V5.7c.6-.3 1-1 1-1.7c0-1.1-.9-2-2-2m-8 17H6v-2h7zm3-6H3V6h13z"/></svg>`
        },
        { 
          text: this.$t("navigation.wallet"), 
          type: "wallet",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="#fff" d="M17.42 3a2 2 0 0 1 1.736 1.008L22.49 9.84a2 2 0 0 1-.322 2.406l-9.283 9.283a1.25 1.25 0 0 1-1.768 0l-9.283-9.283a2 2 0 0 1-.322-2.406l3.333-5.833A2 2 0 0 1 6.58 3zM15 6H9a1 1 0 0 0-.117 1.993L9 8h2v1.545c-.758.07-1.447.217-2.004.426c-.395.148-.749.336-1.013.571s-.483.557-.483.958s.219.724.483.958c.264.235.618.423 1.013.57c.594.223 1.338.377 2.157.44a1 1 0 0 0-.146.416L11 14v2a1 1 0 0 0 1.993.117L13 16v-2a1 1 0 0 0-.153-.532c.819-.063 1.563-.216 2.157-.44c.395-.147.749-.335 1.013-.57s.483-.557.483-.958s-.219-.724-.483-.958c-.264-.235-.618-.423-1.013-.57a7.5 7.5 0 0 0-1.683-.392L13 9.545V8h2a1 1 0 0 0 .117-1.993zm-2.001 4.55a6.8 6.8 0 0 1 1.654.357c.329.124.56.259.7.383a.46.46 0 0 1 .14.178l.007.032l-.007.032a.46.46 0 0 1-.14.178c-.14.124-.371.26-.7.382c-.655.246-1.593.408-2.653.408s-1.998-.162-2.653-.408c-.329-.123-.56-.258-.701-.382a.46.46 0 0 1-.14-.178L8.5 11.5c0-.013.005-.085.146-.21s.372-.26.701-.382c.44-.165 1.007-.293 1.654-.358a1 1 0 0 0 1.998 0"/></g></svg>`
        },
        { 
          text: this.$t("navbar.tab3"), 
          route: "/futures",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512"><path fill="#7b6cb9" d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16M464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96l32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16"/></svg>`
        },
        { 
          text: this.$t("sidebar.rewards"), 
          route: "/rewards",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#7b6cb9" fill-rule="evenodd" d="M7.245 2h9.51c1.159 0 1.738 0 2.206.163a3.05 3.05 0 0 1 1.881 1.936C21 4.581 21 5.177 21 6.37v14.004c0 .858-.985 1.314-1.608.744a.946.946 0 0 0-1.284 0l-.483.442a1.657 1.657 0 0 1-2.25 0a1.657 1.657 0 0 0-2.25 0a1.657 1.657 0 0 1-2.25 0a1.657 1.657 0 0 0-2.25 0a1.657 1.657 0 0 1-2.25 0l-.483-.442a.946.946 0 0 0-1.284 0c-.623.57-1.608.114-1.608-.744V6.37c0-1.193 0-1.79.158-2.27c.3-.913.995-1.629 1.881-1.937C5.507 2 6.086 2 7.245 2m7.815 6.5a.75.75 0 0 0-1.12-1l-3.011 3.374l-.87-.974a.75.75 0 0 0-1.118 1l1.428 1.6a.75.75 0 0 0 1.119 0zM7.5 14.75a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/></svg>`
        },
        { 
          text: this.$t("navigation.chat"), 
          type: "chat",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#7b6cb9" fill-rule="evenodd" d="M20.543 6.704C21 7.807 21 9.204 21 12s0 4.194-.457 5.296a6 6 0 0 1-3.247 3.247C16.194 21 14.796 21 12 21H9c-2.828 0-4.243 0-5.121-.879C3 19.243 3 17.828 3 15v-3c0-2.796 0-4.193.457-5.296a6 6 0 0 1 3.247-3.247C7.807 3 9.204 3 12 3s4.194 0 5.296.457a6 6 0 0 1 3.247 3.247M8 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1" clip-rule="evenodd"/></svg>`
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["generalSidebarMobile", "authUser", "modalsShow"]),
    activeItem() {
      const path = this.$route.path;

      if (this.generalSidebarMobile === "Chat") {
        return this.$t("navigation.chat");
      }
      if (this.generalSidebarMobile === "Navbar") {
        return this.$t("navigation.menu");
      }
      if (this.modalsShow === "Cashier") {
        return this.$t("navigation.wallet");
      }

      if (path === "/") {
        return this.$t("navigation.slot");
      }
      if (path.startsWith("/futures")) {
        return this.$t("navbar.tab3");
      }
      if (path.startsWith("/affiliates")) {
        return this.$t("sidebar.affiliate");
      }
      if (path.startsWith("/rewards")) {
        return this.$t("sidebar.rewards");
      }

      return null;
    }
  },
  methods: {
    ...mapActions(["generalSetSidebarMobile", "modalsSetShow", "toggleSidebar"]),
    navigate(item) {
      const requiresAuth = [
        this.$t("sidebar.affiliate"),
        this.$t("navigation.wallet"),
        this.$t("navbar.tab3"),
        this.$t("sidebar.rewards")
      ];

      if (requiresAuth.includes(item.text) && !this.authUser?.user) {
        this.modalsSetShow("Login");
        return;
      }

      if (item.type === "sidebar") {
        this.toggleSidebar();
      } else if (item.type === "wallet") {
        this.modalsSetShow("Cashier");
      } else if (item.type === "chat") {
        this.generalSetSidebarMobile("Chat");
      } else if (item.route) {
        this.$router.push(item.route);
      }
    }
  }
};
</script>


<style>
.bottom-navigation {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 64px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--bottombar-bg, #111);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 10;

  /* 🔥 yeni eklenenler */
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
 
}
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

/* Pasif ikon rengi */
.nav-icon svg path,
.nav-icon svg circle,
.wallet-icon svg rect {
  fill: #7b6cb9;
}

/* Aktif ikon rengi → Gradient */
.selected .nav-icon svg path,
.selected .nav-icon svg circle,
.selected .wallet-icon svg rect {
  fill: url(#navGradient);
}

/* Yazılar */
.nav-text {
  font-size: 11px;
  color: #7b6cb9;
}
.selected .nav-text {
  color: var(--buttonyellow);
}

/* Wallet */
.wallet-button {
  margin-top: -35px;
}
.hexagon {
  width: 65px;
  height: 65px;
  background: var(--buttonyellow);
  clip-path: polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.wallet-icon svg {
  width: 32px;
  height: 32px;
}

@media only screen and (min-width: 768px) {
   .bottom-navigation {
  display: none;
 
}
    
}
</style>
